export const ORDER_ID = 'order-details'
export const ORDER_DETAILS_ID = ORDER_ID + '-content'

export const PURCHASE_ID = 'purchase-details'
export const PURCHASE_DETAILS_ID = PURCHASE_ID + '-content'
